import { BaseBadge, SmallBaseBadge } from "./BaseBadge";
import { BadgeProps } from "./types";
import "../../designTokens/variables.css";

export const DisabledBadge = (props: BadgeProps) => {
  return (
    <BaseBadge
      backgroundColor="var(--color-primary-100)"
      color="var(--color-primary-900)"
      {...props}
    />
  );
};

export const SmallDisabledBadge = (props: BadgeProps) => {
  return (
    <SmallBaseBadge
      backgroundColor="var(--color-primary-100)"
      color="var(--color-primary-900)"
      {...props}
    />
  );
};
